import JSONModel from "sap/ui/model/json/JSONModel";
import BaseController from "./BaseController";
import { SettingsService } from "../service/Settings.service";
import { Route$PatternMatchedEvent } from "sap/ui/core/routing/Route";
import { GenericTile$PressEvent } from "sap/m/GenericTile";
import { EnvironmentService } from "../service/Environment.service";
import { GeburtstagsKontakt } from "../model/models";

/**
 * @namespace com.unitrade.crm.controller
 */
export default class Home extends BaseController {
  private _birthdaysModel: JSONModel;
  private _settingsModel: JSONModel;
  private _settingsService: SettingsService;

  public override getisNavBackEnabled(): Promise<boolean> {
    return Promise.resolve(false);
  }

  async onInit(): Promise<void> {
    this._settingsService = new SettingsService();
    this._birthdaysModel = new JSONModel({
      enabled: this._settingsService.getBirthdayReminderActive(),
      state: "Loading",
      items: [{}],
    });
    this._settingsModel = new JSONModel({
      showAufgabeAnlegenTile: false,
    });

    this.setModel(this._birthdaysModel, "birthdays");
    this.setModel(this._settingsModel, "settings");
    this.getRouter().getRoute("home").attachPatternMatched(this._onPatternMatch);
  }

  private _onPatternMatch = async (oEvent: Route$PatternMatchedEvent) => {
    const birthDaysEnabled = this._settingsService.getBirthdayReminderActive();
    const userConfig = this._settingsService.getUserConfiguration();
    this._birthdaysModel.setProperty("/enabled", birthDaysEnabled);
    this._settingsModel.setProperty("/showAufgabeAnlegenTile", userConfig.experimentalFeaturesEnabled);

    if (birthDaysEnabled) {
      this._loadBirthdays();
    }
  };

  private _loadBirthdays = async () => {
    this._birthdaysModel.setProperty("/state", "Loading");

    try {
      const birthdays: Array<GeburtstagsKontakt> = await $.getJSON(`${EnvironmentService.getBaseUrl()}/kontakte/geburtstage`);
      if (birthdays.length === 0) {
        this._birthdaysModel.setProperty("/enabled", false);
      }
      this._birthdaysModel.setProperty("/items", birthdays);
      this._birthdaysModel.setProperty("/state", "Loaded");
    } catch (ex: any) {
      this._birthdaysModel.setProperty("/state", "Failed");
    }
  };

  public navigateToCustomers(): void {
    this.getOwnerComponent().getRouter().navTo("customers");
  }

  public navigateToVisitReport(id: number): void {
    this.getOwnerComponent().getRouter().navTo("visitReport", { idPath: id });
  }

  public navigateToArticleList(): void {
    this.getOwnerComponent().getRouter().navTo("articleList");
  }

  public navigateToObjectList(): void {
    this.getOwnerComponent().getRouter().navTo("objectList");
  }

  public onGeburtstagTilePress = (oEvent: GenericTile$PressEvent) => {
    this.getOwnerComponent().getRouter().navTo("birthdayList");
  };

  public navigateToTask(): void {
    this.getOwnerComponent().getRouter().navTo("taskDetails");
  }

  public navigateToAppointments(): void {
    this.getOwnerComponent().getRouter().navTo("appointments");
  }
}
